<template>
	<div class="flow-env-action" :disabled="disabled" :state="state" @click="handleClick($event)">
		<div
			class="flow-env-action-info"
			:nofooter="$slots['footer'] ? false : true"
			:disabled="disableInfo"
			@click="contentClick($event)"
		>
			<slot />
		</div>
		<div
			v-if="$slots['footer']"
			class="flow-env-action-footer flex-gap-8"
			:disabled="disableFooter"
			@click="footerClick($event)"
		>
			<slot name="footer" />
		</div>
		<div v-if="$slots['meta']" class="flow-env-action-meta-icons">
			<slot name="meta" />
		</div>
	</div>
</template>
<script>
import { defineComponent } from "vue";

export default defineComponent({
	name: "EnvironmentAction",
	props: {
		/**
		 * true | false
		 */
		disabled: {
			type: Boolean,
			default: false
		},
		/**
		 * true | false
		 * <br/>Disable only footer
		 */
		disableFooter: {
			type: Boolean,
			default: false
		},
		/**
		 * true | false
		 * <br/>Disable top part/ info part
		 */
		disableInfo: {
			type: Boolean,
			default: false
		},
		/**
		 * 'error' | 'warning' | 'default' | 'primary'
		 */
		state: {
			type: String,
			default: "default",
			validator(value) {
				return ["error", "warning", "default", "primary"].includes(value);
			}
		}
	},
	methods: {
		handleClick(e) {
			/**
			 * Click event.
			 *
			 * @event click
			 */
			this.$emit("click", e);
		},
		footerClick(e) {
			/**
			 * Click on footer event.
			 *
			 * @event footerClick
			 */
			this.$emit("footerClick", e);
		},
		contentClick(e) {
			/**
			 * Click on content event.
			 *
			 * @event contentClick
			 */
			this.$emit("contentClick", e);
		}
	}
});
</script>
<style lang="scss">
$env-action-colors: (
	"error": var(--dashboard-danger-gradient),
	"warning": var(--dashboard-warning-gradient)
);

div.flow-env-action {
	border-radius: 8px;
	border: 1px solid var(--dashboard-border-light);
	background-color: var(--dashboard-element-light) !important;
	cursor: default;
	position: relative;

	display: flex;
	flex-direction: column;
	flex: 0 0 auto;
	// width: 110px;
	min-height: 100px;
	max-height: 100px;
	width: 180px;
	overflow: hidden;

	@each $state, $color in $env-action-colors {
		&[state="#{$state}"] {
			background: $color;
		}
	}

	> div.flow-env-action-info {
		// padding: 16px 0px 16px 0px;

		flex: 1 1 auto;
		display: flex;
		justify-content: flex-start;
		flex-direction: column;
		max-height: 66px;
		// align-items: center;

		&[nofooter] {
			justify-content: center;
			align-items: center;
			max-height: 100px;

			> button {
				margin-bottom: 8px;
			}
		}

		&[disabled] {
			filter: opacity(0.4);
			pointer-events: none;
			&:before {
				content: "";
				position: absolute;
				border-radius: 8px;
				top: 0px;
				bottom: 0px;
				left: 0px;
				right: 0px;
				background-color: var(--dashboard-element-light);
				opacity: 0.4;
				// filter: contrast(45%);
				cursor: not-allowed;
			}
			* {
				cursor: not-allowed !important;
			}
		}
	}

	> div.flow-env-action-footer {
		border-top: 1px solid var(--dashboard-border-light);
		background-color: inherit;
		// padding: 8px;
		height: 32px;
		flex: 0 0 auto;
		display: flex;
		align-items: center;
		justify-content: center;
		position: relative;
		overflow: hidden;
		cursor: pointer;
		&[disabled] {
			filter: opacity(0.4);
			pointer-events: none;
			&:before {
				content: "";
				position: absolute;
				border-radius: 8px;
				top: 0px;
				bottom: 0px;
				left: 0px;
				right: 0px;
				background-color: var(--dashboard-element-light);
				opacity: 0.4;
				// filter: contrast(45%);
				cursor: not-allowed;
			}
			* {
				cursor: not-allowed !important;
			}
		}

		> h5 {
			background-color: inherit;
			display: flex;
			flex: 1 0 auto;
			justify-content: center;
			height: inherit;
			align-items: center;
			&:active {
				filter: contrast(80%);
			}

			&:hover:not(:active) {
				filter: contrast(75%);
			}
		}
	}

	&:not([disabled]) {
		// &:active {
		// 	filter: contrast(90%);
		// }

		// &:hover:not(:active) {
		// 	filter: contrast(95%);
		// }
		&:focus-within {
			box-shadow: inset 0 0 0 2px var(--dashboard-primary);
			outline: none;
		}
	}

	&[disabled] {
		filter: opacity(0.4);
		pointer-events: none;
		&:before {
			content: "";
			position: absolute;
			border-radius: 8px;
			top: 0px;
			bottom: 0px;
			left: 0px;
			right: 0px;
			background-color: var(--dashboard-element-light);
			opacity: 0.7;
			// filter: contrast(45%);
			cursor: not-allowed;
		}
		* {
			cursor: not-allowed !important;
		}
	}

	div.flow-env-action-meta-icons {
		position: absolute;
		top: 8px;
		right: 8px;
		display: inline-flex;
	}

	div.flow-env-action-success-content {
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		align-items: flex-start;
		padding: 8px;
		flex: 1 0 auto;
		> * + * {
			margin-top: 8px;
		}
	}
	div.flow-env-action-footer-split {
		display: flex;
		align-items: center;
		flex: 1 0 auto;
		height: inherit;
		background-color: inherit;
		> * {
			display: flex;
			flex: 1 0 50%;
			align-items: center;
			justify-content: center;
			height: inherit;
			background-color: inherit;

			> * + * {
				margin-left: 4px;
			}
			&:not([disabled]) {
				&:active {
					filter: contrast(80%);
				}

				&:hover:not(:active) {
					filter: contrast(75%);
				}
			}

			&[disabled] {
				filter: opacity(0.4);
				pointer-events: none;
				&:before {
					content: "";
					position: absolute;
					border-radius: 8px;
					top: 0px;
					bottom: 0px;
					left: 0px;
					right: 0px;
					background-color: var(--dashboard-element-light);
					opacity: 0.4;
				}
			}
		}

		> * + * {
			border-left: 1px solid var(--dashboard-border-light);
		}
	}
}
</style>
